import { StateCreator, create } from 'zustand';
import { Auth0Context, AuthBloomaysContext } from '@bloomays-lib/types.shared';
import { AuthFactory } from '../services/authService';

export interface AuthState {
  auth?: AuthBloomaysContext;
  authLoading: boolean;
  authError?: Error;
  authFetch: (auth0: Auth0Context, location: string) => Promise<void>;
}

export const createAuthSlice: StateCreator<AuthState> = (set) => {
  return {
    auth: undefined,
    authLoading: true,
    authError: undefined,
    authFetch: (auth0, location) => {
      return new Promise((resolve, reject) => {
        if (auth0.isLoading) {
          set({ authLoading: true });
          return resolve();
        }
        const result = AuthFactory({ auth0context: auth0, location });
        try {
          set({ auth: result, authLoading: false });
          return resolve();
        } catch (error: unknown) {
          const managedError = new Error("Impossible de charger le profil d'authentification", { cause: error });
          set({ authError: managedError, authLoading: false });
          console.log('authFetch ❌', auth0, JSON.stringify(managedError, null, 2));
          return reject(managedError);
        }
      });
    },
  };
};

export const useAuthStore = create<AuthState>()((...a) => ({
  ...createAuthSlice(...a),
}));
